import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

// Brand guide tag colors: VIP / Premium — lime outline; Staff / Student /
// Scheduled — Accent Blue; Client — Accent Pink. Palette slots keep this
// tenant-brandable (info = blue, warning = pink, primary = the accent).
export const tagPaletteKey = (tag) => {
  const t = (tag || '').toLowerCase();
  if (t === 'vip' || t === 'premium') return 'primary';
  if (t === 'staff' || t === 'student' || t === 'scheduled') return 'info';
  if (t === 'client') return 'warning';
  return null;
};

export const TAGS_EXPLAINER =
  'Tags are free-form labels for grouping and finding people — e.g. vip, student, referral. ' +
  'Start typing in the tag field to reuse existing tags before creating a new one. ' +
  'Some tags (vip, premium, staff, client) get highlighted colors.';

const TagPill = ({ tag }) => {
  const key = tagPaletteKey(tag);
  return (
    <Box
      component="span"
      sx={{
        fontSize: 11.5,
        fontWeight: 500,
        px: 1,
        py: 0.25,
        borderRadius: 999,
        whiteSpace: 'nowrap',
        border: 1,
        borderColor: (t) => (key ? alpha(t.palette[key].main, 0.5) : t.palette.divider),
        color: (t) => (key ? t.palette[key].main : t.palette.text.secondary),
      }}
    >
      {tag}
    </Box>
  );
};

export default TagPill;
